var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-6"},[_c('v-card',{staticClass:"mx-auto",attrs:{"elevation":"0","max-width":"344"}},[_c('v-card-title',[_vm._v("404 - ERROR")]),_c('v-card-subtitle',[_vm._v(" Algo deu errado, tente novamente! ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }